module.exports = __webpack_public_path__ + "4f5f8064512204e2e7851e96a046885a.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1086
// module chunks = 0